<ng-template
  #addressModalContent
  let-modal
>
  <div class="modal-header">
    <h4
      class="modal-title"
      id="modal-basic-title"
    >
      Confirm Address
    </h4>
  </div>
  <div class="modal-body">
    <form
      class="container"
      [formGroup]="addressInputForm"
    >
      <div class="row g-2">
        <div class="col-12 p-1">
          <div
            class="card"
            [class.bg-danger-subtle]="!addressResult?.addressVerdict?.isComplete"
            [class.bg-warning-subtle]="
              addressResult?.addressVerdict?.isComplete &&
              (addressResult?.addressVerdict?.hasInferredAddressLineComponents ||
                addressResult?.addressVerdict?.hasReplacedAddressLineComponents)
            "
          >
            <div class="card-body">
              <h5>What you entered</h5>
              <p style="font-size: larger">{{ addressResult?.address?.combinedAddress }}</p>
              <p
                class="p-1 rounded-1"
                *ngIf="!addressResult?.addressVerdict?.isComplete"
              >
                The address could not be verified or there are missing fields in your entry.
              </p>
              <p
                class="p-1 rounded-1"
                *ngIf="
                  addressResult?.addressVerdict?.hasInferredAddressLineComponents ||
                  addressResult?.addressVerdict?.hasReplacedAddressLineComponents
                "
              >
                Address information was inferred. See below for address components inferred.
                <br />
                <span class="text-muted"
                  >Please use the recommended address or make any changes if the address is
                  incorrect.</span
                >
              </p>
            </div>
            <div class="card-footer">
              @if(addressResult?.addressVerdict?.missingComponentTypes) { @for(field of
              addressResult?.addressVerdict?.missingComponentTypes; track field){
              <div>
                @switch(field){ @case("subpremise"){
                <div>Missing unit or apt #</div>
                } @case("country"){
                <div>Not a valid US Address</div>
                } @default{
                <div>Missing {{ field }}</div>
                } }
              </div>
              } } @if(addressResult?.addressLineComponents){ @for(field of
              addressResult?.addressLineComponents; track field){
              <div
                class="legend"
                *ngIf="field.inferred"
              >
                <span>
                  @switch(field.componentType){ @case("postal_code"){ Zipcode }
                  @case("postal_code_suffix"){ Zipcode Extension }
                  @case("administrative_area_level_1") { State } @case ("locality") { City} }
                </span>
                :
                <strong>{{ field.text }}</strong>
              </div>
              } }
            </div>
          </div>
        </div>
        <div
          class="col-12"
          *ngIf="addressCorrectionRequired"
        >
          @for(component of addressResult?.addressLineComponents; track component){
          <div
            class="mb-1"
            *ngIf="
              ['UNCONFIRMED_AND_SUSPICIOUS', 'UNCONFIRMED_BUT_PLAUSIBLE'].includes(
                component.confirmationLevel!
              )
            "
          >
            <div class="form-label">
              Unverified {{ component.componentType }}
              <strong>{{ component.text }}</strong>
            </div>
          </div>
          }
        </div>
        <div
          class="col-12"
          *ngIf="addressResult?.addressVerdict?.recommended?.formattedAddress"
        >
          <div class="card text-bg-light">
            <div class="card-body">
              <div class="form-check">
                <input
                  class="form-check-input border-dark-subtle"
                  type="radio"
                  checked
                  name="addressChoice"
                  value="recommended"
                />
                <h5>Recommended Address</h5>
                <p>
                  {{ addressResult?.addressVerdict?.recommended?.formattedAddress }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-12 mb-1"
          *ngIf="addressCorrectionRequired"
        >
          <h5>Enter a new address</h5>
          <input
            type="text"
            class="form-control form-control-sm"
            formControlName="addressInput"
            placeholder="Enter an address and then click validate"
            [value]="addressResult?.address?.unformattedAddress"
          />
          <div class="mt-1">
            <h6>Examples:</h6>
            <div>9121 Oakdale Ave #100 91311</div>
            <div>9121 Oakdale Ave LA</div>
            <div>9121 Oakdale Ave Chatsworth</div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-primary"
      [hidden]="addressCorrectionRequired"
      (click)="addressCorrectionRequired = true"
    >
      Make changes
    </button>
    <button
      type="button"
      class="btn btn-outline-primary"
      [hidden]="!addressCorrectionRequired"
      [disabled]="addressInputForm.invalid"
      (click)="validateAddress()"
    >
      Validate
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [hidden]="!addressResult?.addressVerdict?.recommended?.formattedAddress"
      (click)="confirm()"
    >
      Confirm
    </button>
  </div>
</ng-template>
